import { render, staticRenderFns } from "./detailTable12.vue?vue&type=template&id=50f62be8&scoped=true"
import script from "./detailTable12.vue?vue&type=script&lang=js"
export * from "./detailTable12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f62be8",
  null
  
)

export default component.exports